// 全局应用状态
export default {
  namespaced: true,

  state: {
    sidebarCollapsed: false,
    mobileMenuOpen: false,
  },

  mutations: {
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    SET_SIDEBAR(state, val) {
      state.sidebarCollapsed = val
    },
    TOGGLE_MOBILE_MENU(state) {
      state.mobileMenuOpen = !state.mobileMenuOpen
    },
    CLOSE_MOBILE_MENU(state) {
      state.mobileMenuOpen = false
    },
  },

  actions: {
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    setSidebar({ commit }, value) {
      commit('SET_SIDEBAR', value)
    },
    toggleMobileMenu({ commit }) {
      commit('TOGGLE_MOBILE_MENU')
    },
    closeMobileMenu({ commit }) {
      commit('CLOSE_MOBILE_MENU')
    },
  },
}
